import PermissionsHandler from "./abstract/permissions.handler";
import { EntityDto } from "@/server/app.dtos";

export default class EntityPermissions extends PermissionsHandler {
  canView(entity: EntityDto): boolean {
    return true;
  }

  canEdit(entity: EntityDto): boolean {
    return true;
  }

  canDelete(entity: EntityDto): boolean {
    return true;
  }
}
